<template>
	<div class="full-screen-search" id="filter-lodgingg">
		<div class="d-flex justify-content-between px-4 pt-4">
			<p class="raleway-bold-p filter-heading mb-0 pt-1" >Appliquer des filtres</p>
			<div class="close-button" @click="$emit('close')">
				<i class="fas fa-times"></i>
			</div>
		</div>
		<div class="mobile-filter-lodging border-0">
			<roomspace class="bg-light rounded p-3 custom-padding" :options="options" @changedAdults="changedAdults" @changedChilds="changedChilds"></roomspace>
			<multiselectnote class="bg-light rounded p-3 custom-padding" :filterCounts="filterCounts" @checked="onCheck"></multiselectnote>
			<multiselectbudget class="bg-light rounded p-3 custom-padding" :options="options" :filterCounts="filterCounts" @changedBudget="changedBudget"></multiselectbudget>
			<multiselectstanding class="bg-light rounded p-3 custom-padding" :options="options" :filterCounts="filterCounts" @checked="onCheck"></multiselectstanding>
			<multiselectlodgingtype class="bg-light rounded p-3 custom-padding" :options="options" :filterCounts="filterCounts" @checked="onCheck"></multiselectlodgingtype>
			<!-- <multiselectlodgingstyle :stylesMount="stylesMount" :options="options" @checked="onCheck"></multiselectlodgingstyle> -->
			<multiselectservices class="bg-light rounded p-3 custom-padding" :servicesMount="servicesMount" :options="options" :filterCounts="filterCounts" @checked="onCheck"></multiselectservices>
			<!-- <multiselectexperience class="bg-light rounded p-3 custom-padding" :options="options" :filterCounts="filterCounts" @checked="onCheck"></multiselectexperience> -->
			<!-- <multiselectdesires class="bg-light rounded p-3 custom-padding" :desiresMount="desiresMount" :options="options" :filterCounts="filterCounts" @checked="onCheck"></multiselectdesires> -->
			<MultiselectDiscounts class="bg-light rounded p-3 custom-padding" :filterCounts="filterCounts" @checked="onCheck"></MultiselectDiscounts>
			<!--<multiselectbedding :options="options" @checked="onCheck"></multiselectbedding>-->
			<!--<multiselectmeals :options="options" @checked="onCheck"></multiselectmeals>-->
			<SwitchAnimal class="bg-light rounded p-3 custom-padding" :filterCounts="filterCounts" @checked="switched"></SwitchAnimal>
			<SwitchTypeOfTrip class="bg-light rounded p-3 custom-padding" :filterCounts="filterCounts" @checked="switched"></SwitchTypeOfTrip>
			<SwitchKids class="bg-light rounded p-3 custom-padding" :filterCounts="filterCounts" @checked="onCheck"></SwitchKids>
			<SwitchStation class="bg-light rounded p-3 custom-padding" :filterCounts="filterCounts" @checked="onCheck"></SwitchStation>
			<SwitchPMR class="bg-light rounded p-3 custom-padding" :filterCounts="filterCounts" @checked="onCheck"></SwitchPMR>
			<!--		<SwitchFreeCancel @checked="switched"></SwitchFreeCancel>-->
		</div>
		<div class="cta-filter-section">
      <div class="cta-actions">
        <a href="#" class="clear-btn" @click="clearFilters">Tout effacer</a>
        <button class="search-btn" @click="$emit('close')">
          <i class="fas fa-search"></i> RECHERCHER
        </button>
      </div>
    </div>
    </div>
  </template>  

<script>
  import RoomSpace from "pages/destinations/RoomSpace.vue";
	import Multiselectnote from 'pages/destinations/Multiselectnote.vue';
	import Multiselectbudget from 'pages/destinations/Multiselectbudget.vue';
	import Multiselectstanding from 'pages/destinations/Multiselectstanding.vue';
	import Multiselectlodgingtype from 'pages/destinations/Multiselectlodgingtype.vue';
	import Multiselectlodgingstyle from 'pages/destinations/Multiselectlodgingstyle.vue';
	import Multiselectlocations from 'pages/destinations/Multiselectlocations.vue';
	import Multiselectservices from 'pages/destinations/Multiselectservices.vue';
	import Multiselecthobbies from 'pages/destinations/Multiselecthobbies.vue';
	import Multiselectdesires from 'pages/destinations/Multiselectdesires.vue';
	import Multiselectbedding from 'pages/destinations/Multiselectbedding.vue';
	import Multiselectmeals from 'pages/destinations/Multiselectmeals.vue';
	import Multiselectacces from 'pages/destinations/Multiselectacces.vue';
	import SwitchTypeOfTrip from 'pages/destinations/SwitchTypeOfTrip.vue';
	import SwitchFreeCancel from 'pages/destinations/SwitchFreeCancel.vue';
	import SwitchAnimal from 'pages/destinations/SwitchAnimal.vue';
  import Roomspace from "./RoomSpace.vue";
  import SwitchKids from "./SwitchKids.vue";
  import SwitchStation from "./SwitchStation.vue";
  import Multiselectexperience from "./Multiselectexperience.vue";
  import MultiselectDiscounts from "./MultiselectDiscounts.vue";
  import SwitchPMR from "./SwitchPMR.vue";

	export default {
		name: 'filter-lodging',
		props: ['stylesMount', 'servicesMount', 'desiresMount', 'filterCounts'],
		components: {
		    Multiselectexperience,
		    SwitchStation,
		    SwitchKids,
		    Roomspace,
		    SwitchPMR,
			Multiselectnote,
			Multiselectbudget,
			Multiselectstanding,
			Multiselectlodgingtype,
			Multiselectlodgingstyle,
			Multiselectlocations,
			Multiselectservices,
			Multiselecthobbies,
			Multiselectdesires,
			Multiselectbedding,
			Multiselectmeals,
			Multiselectacces,
			SwitchTypeOfTrip,
			SwitchFreeCancel,
			SwitchAnimal,
			MultiselectDiscounts,
		},
		beforeDestroy() {
			// Restore body scroll
			document.body.style.overflow = '';
			document.body.style.position = '';
			document.body.style.top = '';
			document.body.style.width = '';
			
			// Restore scroll position if it was saved
			if (this.scrollPosition !== undefined) {
				window.scrollTo(0, this.scrollPosition);
			}
			
			document.querySelectorAll('.nav-phone').forEach(el => {
				el.style.display = 'block';
			});
			document.querySelectorAll('.top-bar').forEach(el => {
				el.style.display = 'flex';
			});
			const whatsappBtn = document.getElementById('whatsapp-button');
			if (whatsappBtn) {
				whatsappBtn.style.display = 'block';
			}
		},
		mounted() {
			// Save current scroll position
			this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
			
			// Prevent body scroll
			document.body.style.overflow = 'hidden';
			document.body.style.position = 'fixed';
			document.body.style.top = `-${this.scrollPosition}px`;
			document.body.style.width = '100%';
			
			document.querySelectorAll('.nav-phone').forEach(el => {
				el.style.display = 'none';
			});
			document.querySelectorAll('.top-bar').forEach(el => {
				el.style.display = 'none';
			});
			const whatsappBtn = document.getElementById('whatsapp-button');
			if (whatsappBtn) {
				whatsappBtn.style.display = 'none';
			}
			const cta = document.querySelector('.cta-filter-section');
			const filterlodging = document.querySelector('.mobile-filter-lodging');
			const ua = navigator.userAgent;

			// Detect Safari (but not Chrome or Firefox on iOS)
			const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);

			if (isSafari) {
				cta.style.bottom = '80px'; // adjust based on testing
				filterlodging.style.marginBottom = '50px';
			}

		},
		data() {
			return {
				changePet: false,
				changeBusiness: false,
				changeFreeCancel: false,
				changeSmocking: false,
				selectedTrip: [],
				scrollPosition: 0,
				options: [
					{
						text: 'Uno',
						value: 1,
					},
				],
			};
		},
		methods: {
			onCheck(val, name) {
				this.$emit('checked', val, name);
			},
			switched(val, name) {
				this.$emit('switch', val, name);
			},
			switchOffPet() {
				this.changePet = !this.changePet;
			},
			changedBudget(value) {
				this.$emit('changedBudget', value, 'budget');
			},
			changedAdults(value) {
				this.$emit('changedAdults', value, 'adults');
			},
			changedChilds(value) {
				this.$emit('changedChilds', value, 'childs');
			},
			// switchOffBusiness() {
			//   this.changeBusiness = !this.changeBusiness
			//   const val = "voyage d'affaires"
			//   if (this.changeBusiness) {
			//     this.$emit('switched', val , 'type_of_trips')
			//   }
			// },
			switchOffFreeCancel() {
				this.changeFreeCancel = !this.changeFreeCancel;
			},
			switchOffSmocking() {
				this.changeSmocking = !this.changeSmocking;
			},
			clearFilters() {
			this.$emit('checked', null, 'reset_all');
			this.$emit('switch', null, 'reset_all');
			this.$emit('changedBudget', null, 'budget');
			this.$emit('changedAdults', null, 'adults');
			this.$emit('changedChilds', null, 'childs');

			this.changePet = false;
			this.changeBusiness = false;
			this.changeFreeCancel = false;
			this.changeSmocking = false;
			this.selectedTrip = [];

			console.log("Filters have been cleared.");
		},
		},
	};
</script>
<style lang="scss" rel="stylesheet" scoped>
  @import "app/assets/stylesheets/components/lodging-filter.scss";
  .full-screen-search {
  position: fixed;
  inset: 0;
  width: 100% !important;
  height: 100vh;
  background: #fff;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  font-family: 'Raleway', sans-serif;
	overflow: hidden;
  /* Prevent touch scrolling on the modal container */
  touch-action: none;
  /* Ensure modal stays in place on iOS */
  -webkit-overflow-scrolling: touch;
}
#filter-lodgingg{
	z-index: 10000;
}

.mobile-filter-lodging {
  flex: 1;
  overflow-y: auto;
  padding: 1rem 1rem;
  /* Enable smooth scrolling within the modal content */
  -webkit-overflow-scrolling: touch;
  /* Allow touch scrolling only within this container */
  touch-action: pan-y;
	overscroll-behavior: contain;

	.custom-padding {
		margin-top: 1rem !important;
	}
}

.close-button {
  width: 32px;
  height: 32px;
  background: #ddd;
  border-radius: 8px;
  cursor: pointer;
}

.filter-content-wrapper {
  margin-top: 70px;
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.mobile-filter-lodging {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cta-filter-section {
  position: sticky;
  width: 100%;
  background: #fff;
  border-top: 1px solid #eee;
  padding: 1rem;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  pointer-events: auto;
}


.cta-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.clear-btn {
  font-size: 14px;
  color: #999;
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: none;
}

.search-btn {
  background: #3b6152;
  color: #fff;
  border: none;
  padding: 0.6rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
}
.search-btn i {
  margin-right: 8px;
}
input[type="checkbox"]:checked + label::before {
  background-color: #3B6152;
}
</style>
